import type { CSSProperties, ReactNode } from "react";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/cn";

interface Props {
  children: ReactNode;
  className?: string;
  /** Stagger offset in ms. */
  delay?: number;
}

/** Fades and lifts its children in the first time they scroll into view. */
export function Reveal({ children, className, delay = 0 }: Props) {
  const { ref, inView } = useInView<HTMLDivElement>();
  const style: CSSProperties | undefined = delay ? { animationDelay: `${delay}ms` } : undefined;
  return (
    <div
      ref={ref}
      style={style}
      className={cn(inView ? "animate-riseIn motion-reduce:animate-none" : "opacity-0", className)}
    >
      {children}
    </div>
  );
}
